import { createContext } from "react";

export const LenisContext = createContext(null);
